import axios from 'axios';
import getApiBaseUrl from '../GetServer';
import { Blog } from './GetBlogs'; // Reusing the Blog interface

interface BackendResponse {
    status: number;
    message: string;
}

/**
 * Service to edit an existing blog entry.
 * @param payload - The full blog object with updated data.
 * @returns A promise with the backend response.
 */
export const editBlog = async (payload: Blog): Promise<BackendResponse> => {
    try {
        console.log(payload, "asd")

        const baseUrl = getApiBaseUrl();
        const endpoint = `${baseUrl}dash/edit-blog`;

        const token = localStorage.getItem('token');

        if (!token) {
            throw new Error('Token no disponible');
        }

        const response = await axios.post<BackendResponse>(endpoint, payload, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
        });

        if (response.data.status !== 200) {
            throw new Error(response.data.message || 'Error desconocido al editar el blog');
        }

        return response.data;
    } catch (error) {
        console.error("Error al editar el blog. Payload enviado:", payload);
        if (axios.isAxiosError(error)) {
            console.error("Detalles del error de Axios:", error.response?.data);
            if (error.response) {
                throw new Error(error.response.data.message || 'Error al conectar con el servidor');
            }
        }
        throw error;
    }
};
